// Device facts for the iOS Add-to-Home-Screen hint (IMPLEMENTATION §3 M11, §6.3 "Add to Home Screen
// first"). PURE on its inputs; `deviceInfo(win)` reads them from the browser.
//   iosSafari   iPhone / iPod / iPad (iPadOS reports "Macintosh" + touch points) in Safari itself — not
//               Chrome / Firefox / Edge / Opera / the Google app or an in-app web view (no "Safari/" token),
//               which cannot offer Add to Home Screen the same way.
//   standalone  already running from the Home Screen (navigator.standalone on iOS, or display-mode).

export interface DeviceInput {
  ua: string;
  maxTouchPoints: number;
  /** navigator.standalone (iOS only; undefined elsewhere). */
  navStandalone: boolean | undefined;
  /** matchMedia('(display-mode: standalone)').matches (or fullscreen). */
  displayStandalone: boolean;
}

export interface DeviceInfo {
  ios: boolean;
  iosSafari: boolean;
  standalone: boolean;
}

const OTHER_IOS_BROWSERS =
  /CriOS|FxiOS|EdgiOS|OPiOS|OPT\/|GSA\/|YaBrowser|DuckDuckGo|FBAN|FBAV|Instagram|Line\//;

export function classifyDevice(d: DeviceInput): DeviceInfo {
  const iPhoneLike = /iPhone|iPod|iPad/.test(d.ua);
  const iPadOs = /Macintosh/.test(d.ua) && d.maxTouchPoints > 1;
  const ios = iPhoneLike || iPadOs;
  const safari = /Safari\//.test(d.ua) && /Version\//.test(d.ua) && !OTHER_IOS_BROWSERS.test(d.ua);
  return {
    ios,
    iosSafari: ios && safari,
    standalone: d.navStandalone === true || d.displayStandalone,
  };
}

export function deviceInfo(win: Window): DeviceInfo {
  const nav = win.navigator as Navigator & { standalone?: boolean };
  let display = false;
  try {
    display =
      win.matchMedia('(display-mode: standalone)').matches ||
      win.matchMedia('(display-mode: fullscreen)').matches;
  } catch {
    display = false;
  }
  return classifyDevice({
    ua: nav.userAgent,
    maxTouchPoints: nav.maxTouchPoints ?? 0,
    navStandalone: nav.standalone,
    displayStandalone: display,
  });
}
